<template>
  <div id="subtest-form">
    <div class="form-horizontal form-bordered">
      <div class="form-group">
        <label class="col-md-2 control-label">Kode Tryout</label>
        <div class="col-md-8 col-xs-12"><strong>{{ $store.state.tryout.code }}</strong></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Jenjang Tryout</label>
        <div class="col-md-8 col-xs-12"><strong>{{ $store.state.tryout.level }} / {{ $store.state.tryout.type }} </strong></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Nama Tryout</label>
        <div class="col-md-8 col-xs-12"><strong>{{ $store.state.tryout.name }}</strong></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Durasi (Menit)</label>
        <div class="col-md-8 col-xs-12"><input type="number" class="form-control" v-model="subtest.duration" step="0.5"></div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Mata Pelajaran *</label>
        <div class="col-md-8 col-xs-12">
          <app-choosemapel v-on:selected="mapelSelected($event)" v-if="$store.state.tryout.status"></app-choosemapel>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Perakitan Test *</label>
        <div class="col-md-8 col-xs-12">
          <app-assemblesubtest :subject="subject" v-if="subject" v-on:updated="detailsUpdated($event)"></app-assemblesubtest>
        </div>
      </div>
    </div>
    <hr>
    <button class="btn btn-success pull-right" @click="save()">Simpan</button>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import ChooseMapel from "@/components/tryout/ChooseMapel";
import AssembleSubTest from "@/components/tryout/AssembleSubTest";
import Subtest from "@/components/tryout/models/Subtest.js";
import TryoutService from "@/services/tryout.js";
import Spinner from "@/components/plugins/Spinner";

export default {
  name: "subtest-form",
  components: {
    "app-choosemapel": ChooseMapel,
    "app-assemblesubtest": AssembleSubTest,
    "app-spinner": Spinner
  },
  data: function() {
    return {
      subtest: {
        id: 0,
        tryout_id: 0,
        subject_code: '',
        subject_name: '',
        subject_picture: '',
        duration: 35,
        item_count: 0,
        details: []
      },
      subject: null,
      isLoading: false
    };
  },
  methods: {
    mapelSelected: function(data) {
      this.subject = data;
      this.subtest.subject_code = this.subject.code;
      this.subtest.subject_name = this.subject.nama;
      this.subtest.subject_picture = this.subject.picture;
    },
    detailsUpdated: function(data) {
      this.subtest.tryout_id = this.$store.state.tryout.id;
      this.subtest.details = data;
      this.subtest.item_count = data.length;
    },
    save: function() {
      this.isLoading = true;
      var context = this;

      if(this.subtest.id != 0) {
        TryoutService.updateSubtest(this.subtest, function(result) {
          context.isLoading = false
          if (result.success) {
            context.$store.commit('tryout_edit_subtest', result.data)
            context.$emit('completed')
          }
        })
      } else {
        TryoutService.saveSubtest(this.subtest, function(result) {
          context.isLoading = false
          if (result.success) {
            context.$store.commit("tryout_add_subtest", result.data);
            context.$emit('completed')
          }
        })
      }
    }
  },
  mounted: function() {
    if (this.$store.getters.selectedSubtest) {
      this.subtest = this.$store.getters.selectedSubtest
      this.subject = {
        nama: this.subtest.subject_name,
        code: this.subtest.subject_code,
        picture: this.subtest.subject_picture
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// SubtestForm.vue?815bb510